<template>
	<div class="userInfoContainer">
		<div class="userInfoItem">
			<div class="itemTitle">
				会员信息
			</div>
			<div class="itemContent">
				<div class="phoneEmailSettingBox">
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							会员名称:
							<span v-if="userInfo.level != 1">{{userInfo.level_name ? userInfo.level_name : ''}}</span>
							<span v-else>您暂不是平台会员</span>
						</div>
					</div>
					<div class="phoneEmailSettingItem" v-if="userInfo.level != 1">
						<div class="phoneEmailSettingItemContent">
							会员到期时间:
							<span>{{userInfo.vip_end_time ? userInfo.vip_end_time : ''}}到期，剩余{{userInfo.day ? userInfo.day : 0}}天</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="userInfoItem" v-if="userInfo.level != 1">
			<div class="itemTitle">
				今日作品兑换次数
			</div>
			<div class="itemContent">
				<div class="phoneEmailSettingBox">
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							总次数:
							<span>{{userInfo.all_count ? userInfo.all_count : 0}}次</span>
						</div>
					</div>
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							剩余次数：
							<span>{{userInfo.max_count ? userInfo.max_count : 0}}次</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="userInfoItem">
			<div class="itemTitle">
				会员套餐
			</div>
			<div class="itemContent">
				<div class="vipList">
					<div class="vipItem" v-for="(item,index) in levelData" :key="index">
						<div class="vipTitle">
							{{item.title}}
						</div>
						<div class="dwonloadNum">
							日作品下载数量：
							<span>{{item.xf_count}}</span>
						</div>
						<div class="dwonloadNum">
							会员金额：
							<span>¥{{item.price}}</span>
						</div>
						<div class="nowbuy" @click="memberOrderAdd(item)">立即购买</div>
					</div>
				</div>
			</div>
		</div>
		<div class="userInfoItem" style="border-bottom: none;">
			<div class="itemTitle">
				会员权益
			</div>
			<div class="itemContent">
				<div class="membership" v-html="vipContent"></div>
			</div>
		</div>
		<PopToast :imgPtahUrl="require('@/assets/Register/bulb.png')" :desc="'温馨提示：'" :descTwo="'会员订单下单后，暂不支持退单！'"
			@clickOk="bulbPop = false;payOrder()" v-if="bulbPop" />
		<PayDialog :show="dialogPayViable" :orderType="1" :payUrl="payUrl" :orderId="orderId"
			@close="dialogPayViable = false" @success="paySucPop = true;userDetails()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'购买成功'" @clickOk="paySucPop = false"
			v-if="paySucPop" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import PayDialog from '../components/PayDialog.vue'
	export default {
		components: {
			PopToast,
			PayDialog
		},
		data() {
			return {
				payUrl: '',
				orderId: '',
				bulbPop: false,
				paySucPop: false,
				userInfo: {},
				levelData: [],
				vipContent: '',
				dialogPayViable: false,
			}
		},
		mounted() {
			this.levelList()
			this.configData()
			this.userDetails()
		},
		methods: {
			//用户详情
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
						this.ruleForm.cate = res.data.image_fl ? res.data.image_fl.split(',') : []
						this.ruleForm.purpose = res.data.image_yt ? res.data.image_yt.split(',') : []
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//创建订单
			memberOrderAdd(item) {
				this.$api.post('/OrderIntegral/vip_order_add', {
					goods_id: item.id,
				}).then(res => {
					if (res.code == 1) {
						this.orderId = res.data
						this.bulbPop = true
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//去支付
			payOrder() {
				this.$api.post('/Tonglian/nativepay', {
					id: this.orderId,
				}).then(res => {
					if (res.code == 1) {
						this.payUrl = res.data
						this.dialogPayViable = true
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//会员权益
			configData() {
				this.$api.post('/Other/config', {}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							if (item.title == 'vip_content') {
								this.vipContent = this.formatRichText(this.px2rem(item.value))
							}
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			px2rem(html, base = 100) {
				if (!html) return html
				return html.replace(/(\d+(\.\d+)?)px/g, (_, px) => {
					return (px / base).toFixed(4) + 'rem'
				})
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					match = match.replace(/style=""/gi, '').replace(/style=''/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match) {
					match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi,
						'width:100%;');
					return match;
				});
				newContent = newContent.replace(/<img/gi,
					'<img style="width:100%;height:auto;display:block;margin:0px 0;"');

				return newContent;
			},
			//会员套餐列表
			levelList() {
				this.$api.post('/Other/level_list', {}).then(res => {
					if (res.code == 1) {
						this.levelData = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@media (max-width: 480px) {
		.userInfoContainer {
			display: flex;
			flex-direction: column;
			padding: .16rem .4rem .48rem;
		}

		.userInfoItem {
			display: flex;
			flex-direction: column;
			padding-bottom: .24rem;
			border-bottom: .01rem solid rgba(255, 255, 255, .2);

			.itemTitle {
				margin-top: .48rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 600;
				font-size: .32rem;
				color: rgba(255, 255, 255, .8);

				.addAddress {
					font-weight: 400;
					font-size: .24rem;
					color: #333333;
					cursor: pointer;
				}
			}

			.itemContent {
				display: flex;
				flex-direction: column;
				position: relative;

				.membership {
					margin-top: .48rem;
					font-weight: 400;
					font-size: .28rem;
					color: #B9B9BB;
					line-height: .4rem;
				}

				.vipList {
					margin-top: .48rem;
					display: flex;

					.vipItem:nth-child(3) {
						margin-right: 0;
					}

					.vipItem {
						margin-right: .24rem;
						display: flex;
						flex-direction: column;
						width: 3.57rem;
						height: 4.36rem;
						background: rgba(216, 216, 216, .1);

						.vipTitle {
							margin-bottom: .16rem;
							display: flex;
							align-items: center;
							justify-content: center;
							width: 3.57rem;
							height: .96rem;
							background: rgba(22, 115, 230, .4);
							font-weight: 500;
							font-size: .32rem;
							color: #FFFFFF;
							line-height: .48rem;
						}

						.dwonloadNum {
							margin: .16rem .2rem 0;
							display: flex;
							align-items: center;
							justify-content: space-between;
							font-weight: 400;
							font-size: .28rem;
							color: #B9B9BB;
							line-height: .4rem;

							span {
								color: rgba(255, 255, 255, 1)
							}
						}

						.nowbuy {
							margin: .64rem auto 0;
							display: flex;
							align-items: center;
							justify-content: center;
							width: 2.16rem;
							height: .72rem;
							background: #1673E6;
							border-radius: .36rem;
							font-weight: 500;
							font-size: .24rem;
							color: #FFFFFF;
							cursor: pointer;
						}
					}
				}

				.phoneEmailSettingBox {
					margin-top: .24rem;
					display: flex;
					align-items: center;

					.phoneEmailSettingItem {
						margin-right: .4rem;
						display: flex;
						align-items: center;

						.phoneEmailSettingItemContent {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: rgba(185, 185, 187, 1);

							span {
								margin-left: .08rem;
								font-weight: 500;
								font-size: .18rem;
								color: rgba(255, 255, 255, 1);
							}
						}

						.edit {
							margin-left: .08rem;
							width: .34rem;
							height: .2rem;
							background: rgba(152, 232, 62, .1);
							border-radius: .02rem;
							font-weight: 400;
							font-size: .12rem;
							color: rgba(152, 232, 62, 1);
							line-height: .2rem;
							text-align: center;
							cursor: pointer;
						}
					}
				}

				.register-form {
					margin-top: .16rem;

					::v-deep .el-form-item {
						margin-bottom: .24rem;

						&__label {
							font-size: 0.14rem;
							color: rgba(255, 255, 255, .8);
							line-height: .52rem;
							padding: 0 .12rem 0 0;
						}
					}

					.form-group {
						margin-top: .16rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
					}

					.invite-container {
						width: 3rem;
						height: 0.52rem;
						border: none;
						border-radius: 0.04rem;
						background: rgba(255, 255, 255, .08);
						padding: 0 0.16rem;
						font-size: 0.14rem;
						color: #333333;
						line-height: .52rem;
						outline: none;
						display: flex;
						align-items: center;
						justify-content: space-between;
						position: relative;

						.showPwd {
							position: absolute;
							top: calc(50% - .12rem);
							right: .1rem;
							width: .24rem;
							height: .24rem;
							cursor: pointer;
						}
					}

					.invite-input {
						width: 1.8rem;
						height: 0.4rem;
						background: none;
						border: none;
						outline: none;
						padding: 0 0;
						font-size: 0.14rem;
						color: rgba(255, 255, 255, 1);

						&::placeholder {
							color: #999999;
						}
					}

					.save-btn {
						margin-top: .08rem;
						margin-left: 1.2rem;
						width: 1.22rem;
						height: .36rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .18rem;
						font-weight: 500;
						font-size: .12rem;
						color: rgba(255, 255, 255, 1);
						line-height: .36rem;
						text-align: center;
						padding: 0 0;

					}

					// 错误提示样式
					.error-message {
						margin-right: .2rem;
						background: #F56C6C;
						padding: 0.04rem 0.09rem;
						border-radius: 0.02rem;
						font-weight: 400;
						font-size: 0.12rem;
						color: #FFFFFF;
						line-height: .18rem;
					}
				}
			}
		}
	}

	@media (min-width: 481px) {
		.userInfoContainer {
			display: flex;
			flex-direction: column;
			padding: .16rem .4rem .48rem;
		}

		.userInfoItem {
			display: flex;
			flex-direction: column;
			padding-bottom: .24rem;
			border-bottom: .01rem solid rgba(255, 255, 255, .2);

			.itemTitle {
				margin-top: .24rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 600;
				font-size: .16rem;
				color: rgba(255, 255, 255, .8);

				.addAddress {
					font-weight: 400;
					font-size: .12rem;
					color: #333333;
					cursor: pointer;
				}
			}

			.itemContent {
				display: flex;
				flex-direction: column;
				position: relative;

				.membership {
					margin-top: .24rem;
					font-weight: 400;
					font-size: .14rem;
					color: #B9B9BB;
					line-height: 20px;
				}

				.vipList {
					margin-top: .24rem;
					display: flex;

					.vipItem {
						margin-right: .24rem;
						display: flex;
						flex-direction: column;
						width: 2rem;
						height: 2.18rem;
						background: rgba(216, 216, 216, .1);

						.vipTitle {
							margin-bottom: .08rem;
							display: flex;
							align-items: center;
							justify-content: center;
							width: 2rem;
							height: .48rem;
							background: rgba(22, 115, 230, .4);
							font-weight: 500;
							font-size: .16rem;
							color: #FFFFFF;
							line-height: .24rem;
						}

						.dwonloadNum {
							margin: .16rem .2rem 0;
							display: flex;
							align-items: center;
							justify-content: space-between;
							font-weight: 400;
							font-size: .14rem;
							color: #B9B9BB;
							line-height: .2rem;

							span {
								color: rgba(255, 255, 255, 1)
							}
						}

						.nowbuy {
							margin: .32rem auto 0;
							display: flex;
							align-items: center;
							justify-content: center;
							width: 1.08rem;
							height: .36rem;
							background: #1673E6;
							border-radius: .18rem;
							font-weight: 500;
							font-size: .12rem;
							color: #FFFFFF;
							cursor: pointer;
						}
					}
				}

				.phoneEmailSettingBox {
					margin-top: .24rem;
					display: flex;
					align-items: center;

					.phoneEmailSettingItem {
						margin-right: .4rem;
						display: flex;
						align-items: center;

						.phoneEmailSettingItemContent {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: rgba(185, 185, 187, 1);

							span {
								margin-left: .08rem;
								font-weight: 500;
								font-size: .18rem;
								color: rgba(255, 255, 255, 1);
							}
						}

						.edit {
							margin-left: .08rem;
							width: .34rem;
							height: .2rem;
							background: rgba(152, 232, 62, .1);
							border-radius: .02rem;
							font-weight: 400;
							font-size: .12rem;
							color: rgba(152, 232, 62, 1);
							line-height: .2rem;
							text-align: center;
							cursor: pointer;
						}
					}
				}

				.register-form {
					margin-top: .16rem;

					::v-deep .el-form-item {
						margin-bottom: .24rem;

						&__label {
							font-size: 0.14rem;
							color: rgba(255, 255, 255, .8);
							line-height: .52rem;
							padding: 0 .12rem 0 0;
						}
					}

					.form-group {
						margin-top: .16rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
					}

					.invite-container {
						width: 3rem;
						height: 0.52rem;
						border: none;
						border-radius: 0.04rem;
						background: rgba(255, 255, 255, .08);
						padding: 0 0.16rem;
						font-size: 0.14rem;
						color: #333333;
						line-height: .52rem;
						outline: none;
						display: flex;
						align-items: center;
						justify-content: space-between;
						position: relative;

						.showPwd {
							position: absolute;
							top: calc(50% - .12rem);
							right: .1rem;
							width: .24rem;
							height: .24rem;
							cursor: pointer;
						}
					}

					.invite-input {
						width: 1.8rem;
						height: 0.4rem;
						background: none;
						border: none;
						outline: none;
						padding: 0 0;
						font-size: 0.14rem;
						color: rgba(255, 255, 255, 1);

						&::placeholder {
							color: #999999;
						}
					}

					.save-btn {
						margin-top: .08rem;
						margin-left: 1.2rem;
						width: 1.22rem;
						height: .36rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .18rem;
						font-weight: 500;
						font-size: .12rem;
						color: rgba(255, 255, 255, 1);
						line-height: .36rem;
						text-align: center;
						padding: 0 0;

					}

					// 错误提示样式
					.error-message {
						margin-right: .2rem;
						background: #F56C6C;
						padding: 0.04rem 0.09rem;
						border-radius: 0.02rem;
						font-weight: 400;
						font-size: 0.12rem;
						color: #FFFFFF;
						line-height: .18rem;
					}
				}
			}
		}
	}
</style>
<style>
	.membership p {
		color: rgba(255, 255, 255, .8) !important;
	}
</style>